import { ModuleFE_FHIRResourceSubtype } from '../../_entity.js';
export const newFHIRQueryTemplate = () => {
    const subType = ModuleFE_FHIRResourceSubtype.cache.all()[0];
    return Object.freeze({
        label: 'New FHIR Query',
        subtypeId: subType._id,
        params: {},
        optionalDynamicParams: [],
        __fhirParamIds: [],
        __fhirParamValueIds: [],
    });
};
//# sourceMappingURL=consts.js.map